import * as actionTypes from './constants';
import * as phases from '../utils/helpers/phases';
const initialState = {
  phase: phases.INIT,
  data: {},
  history: [],
  next: {},
  details: undefined
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_PAYMENT_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED,
        data: action.payment
      };
    case actionTypes.GET_PAYMENT_REQUEST:
      return {
        ...state,
        phase: phases.LOADING
      };

    case actionTypes.GET_PAYMENT_REJECT:
      return {
        ...state,
        phase: phases.ERROR
      };

    case actionTypes.GET_PAYMENT_HISTORY_SUCCESS:
      return {
        ...state,
        history: action.history
      };

    case actionTypes.GET_NEXT_PAYMENT_SUCCESS:
      return {
        ...state,
        next: action.payment
      };

    case actionTypes.GET_PAYMENT_DETAILS_SUCCESS:
      return {
        ...state,
        details: action.details
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/payment/reducer.js